import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { StrictMode } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
var informationalMessage = null;
if (process.env.NODE_ENV === "development" && window.location === window.parent.location) {
    informationalMessage =
        process.env.REACT_APP_MERGE_ENV === "PRODUCTION" ? (_jsxs(_Fragment, { children: [_jsx("h1", { children: "You got agent-handler-chat running! [PRODUCTION]" }), _jsx("p", { children: "This is the chat widget iframe. It should be embedded in a parent page." })] })) : (_jsxs(_Fragment, { children: [_jsx("h1", { children: "You got agent-handler-chat running!" }), _jsx("p", { children: "This is the chat widget iframe. It should be embedded in a parent page." })] }));
}
ReactDOM.render(_jsxs(StrictMode, { children: [informationalMessage, _jsx(App, {})] }), document.body);
